import React, { useEffect, useState } from 'react'
import './browse.css'
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCart} from "react-use-cart";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useNavigate } from "react-router-dom";
import Fuzzy from './fuzzy'
import { useIdleTimer } from 'react-idle-timer'
import Swal from 'sweetalert2';
import ScaleLoader from "react-spinners/ScaleLoader";

const Browse = (() => {
    const [products, setProducts] = useState([])
    const [newProducts, setNewProducts] = useState([])
    const [group, setGroup] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        setTimeout( () => {
            setLoading(false)
        }, 700)

    },[])
   
    useEffect(async () => {
        let products = await axios.get(`https://peaceful-garden-23768.herokuapp.com/api/product-management/product/browse`)

        setProducts(products.data)
    }, [])


    useEffect(() => {

        const newProducts = products.map(
            ({ product_id, product_name, price, img, category_name }) => ({
                id: product_id,
                name: product_name,
                price: price,
                img: img,
                category: category_name
            })
        )
        setNewProducts(newProducts)

    }, [products])


    useEffect(async () => {
        let group = await newProducts.reduce((r, a) => {
            r[a.category] = [...r[a.category] || [], a];
            return r
        }, {})

        setGroup(group)

    }, [newProducts])
    
    const navigate = useNavigate()

    const handleOnIdle = () => {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'You were idle for too long!',
          })
        navigate('/idle')
      }
    
   useIdleTimer({
        timeout: 1000 * 60 * 10,
        onIdle: handleOnIdle,
      })
      console.log()
      
    const { addItem } = useCart();

  
    const getData = () => {
        let data = {...group}
        let html = []

        for(const [key, value] of Object.entries(data)) {
            html.push(
                <TabPanel className='container'>
                    <div className='col-11' style={{marginLeft:15}}>{key && value && value.length > 0
                    ? value.map(product => {
                        const { id, name, price, img } = product
                        return (
                            <div className="col-sm-3 col-md-3 product" key={id}>
                                <div className='productContainer'>
                                    <img src={img} className='productImage' alt='' style={{paddingTop: 10}} />
                                    <div>
                                        <strong>{name}</strong>
                                    </div>
                                    <div className='productPrice'>
                                        <strong>${price}</strong>  <button className='add' onClick={() => addItem(product)}>Add to Cart</button>
                                    </div>

                                    {/* <button onClick={()=>navigate('/productdetails', product)}>Choose Item</button> */}
                                </div>
                            </div>
                        )
                    })
                    : "Loading..."}</div>
                </TabPanel>
            )
        }

        return html
    }
    
    return (
        <div className='parent'>
        { loading ?  
            <div className='spinner'>
            <ScaleLoader color={'#ffa500'} loading={loading} />
            </div>
           : 
        <div>
           <Fuzzy />
          

            <div className='menu' >
                <Tabs>
                    <TabList>
                        <Tab>Burgers</Tab>
                        <Tab>Pastas</Tab>
                        <Tab>Pizzas</Tab>
                        <Tab>Sides</Tab>
                        <Tab>Drinks</Tab>
                    </TabList>

                    {getData()}
                </Tabs>

                <p>
               
                </p>
            </div>
       
        </div>
        }
        </div>

    )


})


export default Browse